import React from 'react';
import { Alert } from '@mui/material';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Button from '../../../../../../muiComponents/Button';
import {
    ComplementaryHotelImageTypeState,
    VisibleContentScope,
} from '../../../../types/zitoneoServicesTypes';
import AddZitoneoImagePanel from './AddZitoneoImagePanel';
import { useZitoneoImagesPopUp } from '../../../../contexts/ZitoneoImagesContext';
import { useZitoneoUI } from '../../../../contexts/ZitoneoUIContext';
import LoadingPlaceholder from '../../../../../../muiComponents/LoadingPlaceholder';
import { useZitoneoHotelRooms } from '../../../../contexts/ZitoneoContentContext';

interface ImagesTabHeaderProps {
    category: ComplementaryHotelImageTypeState | null;
    title: string;
}

const ImagesTabHeader = ({ category, title }: ImagesTabHeaderProps) => {
    const translate = useTranslate();
    const { isLoading, visibleContentScope, selectedRoomId } = useZitoneoUI();
    const { rooms } = useZitoneoHotelRooms();
    const {
        isImagePopUpOpen,
        handleOpenImagePopUp,
        handleSelectImageType,
        handleSelectRoom,
    } = useZitoneoImagesPopUp();

    return (
        <div>
            <div className='services-page__header__container'>
                <div className='services-page__header'>
                    <div className='services-page__titles_container'>
                        {isLoading ? (
                            <>
                                <LoadingPlaceholder
                                    variant='text'
                                    width={200}
                                    height={24}
                                />
                                <LoadingPlaceholder
                                    variant='text'
                                    width={60}
                                    height={40}
                                />
                            </>
                        ) : (
                            <>
                                <h3 className='services-page__overtitle'>
                                    {`${translate('category')} · ${
                                        category?.Name || translate('all')
                                    }`}
                                </h3>
                                <h2 className='services-page__title'>
                                    {title}
                                </h2>
                            </>
                        )}
                    </div>
                    <Button
                        variant='contained'
                        startIcon='FileUploadOutlined'
                        disabled={isLoading}
                        onClick={() => {
                            handleOpenImagePopUp(true);
                            handleSelectImageType(category);
                            handleSelectRoom(
                                visibleContentScope === VisibleContentScope.ROOM
                                    ? rooms.find(
                                          room => room.Id === selectedRoomId
                                      ) || null
                                    : null
                            );
                        }}
                    >
                        {translate('add_images')}
                    </Button>
                </div>
            </div>
            {!isLoading && (
                <Alert severity='info'>
                    {translate('published_images_public_visibility')}
                </Alert>
            )}
            {isImagePopUpOpen && (
                <AddZitoneoImagePanel
                    open={isImagePopUpOpen}
                    onClose={() => handleOpenImagePopUp(false)}
                />
            )}
        </div>
    );
};

export default ImagesTabHeader;
